import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/helpers';
import { LayoutComponent } from './navigation/layout/layout/layout.component';
import { AppGuard } from './shared/guards/app.guard';

const routes: Routes = [
  {
    path: 'app',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        canActivate: [AppGuard],
        loadChildren: () =>
          import('./dashboard/dashboard.module').then((x) => x.DashboardModule),
        data: { key: 'dashboardAccess' },
      },
      {
        path: 'my-profile',
        loadComponent: () =>
          import('./my-profile/my-profile.component').then(
            (m) => m.MyProfileComponent
          ),
      },
      {
        path: 'projects',
        canActivate: [AppGuard],
        loadChildren: () =>
          import('./projects/project.module').then((x) => x.ProjectModule),
        data: { key: 'projectAccess' },
      },
      {
        path: 'employees',
        canActivate: [AppGuard],
        loadChildren: () =>
          import('./employee/employee.module').then((x) => x.EmployeeModule),
        data: { key: 'employeeAccess' },
      },
      {
        path: 'reports',
        canActivate: [AppGuard],
        loadChildren: () =>
          import('./reports/reports.module').then((x) => x.ReportsModule),
        data: { key: 'reportAccess' },
      },
      {
        path: 'clients',
        canActivate: [AppGuard],
        loadChildren: () =>
          import('./client/client.module').then((x) => x.ClientModule),
        data: { key: 'clientAccess' },
      },
      {
        path: 'user',
        canActivate: [AppGuard],
        loadChildren: () =>
          import('./user/user.module').then((x) => x.UserModule),
        data: { key: 'userAccess' },
      },
      {
        path: 'assets',
        canActivate: [AppGuard],
        loadChildren: () =>
          import('./asset/asset.module').then((x) => x.AssetModule),
        data: { key: 'assetAccess' },
      },
      {
        path: 'settings',
        canActivate: [AppGuard],
        loadChildren: () =>
          import('./settings/settings.module').then((x) => x.SettingsModule),
        data: { key: 'settingAccess' },
      },
      {
        path: 'campus',
        canActivate: [AppGuard],
        loadChildren: () =>
          import('./campus/campus.module').then((x) => x.CampusModule),
        data: { key: 'campusAccess' },
      },
      {
        path: 'offer-letter',
        canActivate: [AppGuard],
        loadChildren: () =>
          import('./offer-letter/offer-letter.module').then(
            (x) => x.OfferLetterModule
          ),
        data: { key: 'campusAccess' },
      },
      {
        path: 'approvals',
        canActivate: [AppGuard],
        loadChildren: () =>
          import('./approvals/approvals.module').then((x) => x.ApprovalsModule),
        data: { key: 'approvalAccess' },
      },
      {
        path: 'reset',
        loadChildren: () =>
          import('./reset-password/reset-password.module').then((x) => x.ResetPasswordModule),
      },
      {
        path: 'vendor',
        canActivate: [AppGuard],
        loadChildren: () =>
          import('./vendor/vendor.module').then((x) => x.VendorModule),
        data: { key: 'vendorAccess' }
      },
      {
        path: 'expense',
        canActivate: [AppGuard],
        loadChildren: () =>
          import('./expense/expense.module').then((x) => x.ExpenseModule),
        data: { key: 'expenseAccess' }
      },
      {
        path: 'helpdesk',
        loadChildren: () =>
          import('./ticket/routes/ticket.routes').then((x) => x.TICKET_ROUTE),
        data: { key: 'helpdeskSRMgmtAccess' }
      },
      {
        path: 'learn-development',
        canActivate: [AppGuard],
        loadChildren: () =>
          import('./learn-development/learn-development.module').then((x) => x.LearnDevelopmentModule),
        data: { key: 'learnDevelopmentAccess' }
      },
      {
        path: 'rolePermission-testing',
        loadComponent: () =>
          import('./permissions/permissions-table/permissions-table.component').then(
            (m) => m.RolePermissionManagerComponent
          ),
      },
    ],
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((x) => x.AuthModule),
  },

  // otherwise redirect to home
  { path: '**', redirectTo: 'app' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
